import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import Footer from "../footer/Footer"

import * as s from "./Layout.module.scss"

const Layout = ({ children }) => {
  const pageLocked = useSelector(state => state.app.pageLocked)
  return (
    <>
      <div className={`${s.Layout} ${pageLocked ? s.Layout___locked : ""}`}>
        <main>{children}</main>

        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
